import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://iigejxbautafmhbavogx.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlpZ2VqeGJhdXRhZm1oYmF2b2d4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE3NDY0MDYsImV4cCI6MjA5NzMyMjQwNn0.GMnAHjveb1HBx7iCjLLmrTExwocXPsaBhwuKu4y6q6A'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)